import { AVATAR_PIXEL_SIZE_UNIT, AVATAR_SIZE_MAP, IAvatarSize } from "src/components-mui/base/avatar/avatar.constants";
import { buildImageSources, IImageSources } from "src/utils/responsive-image-util";

export const getAvatarPixelSize = (size: IAvatarSize | IAvatarSize[]) => {
    const sizes = typeof size === "string" ? [size] : size;
    return Math.max(...sizes.map(value => AVATAR_SIZE_MAP[value])) * AVATAR_PIXEL_SIZE_UNIT;
};

export const toResponsiveValue = <T>(size: IAvatarSize | IAvatarSize[], mapSize: (value: IAvatarSize) => T): T | T[] => {
    if (typeof size === "string") {
        return mapSize(size);
    }

    return size.map(mapSize);
};

export const buildAvatarImageSources = ({ imageUrl, size }: { imageUrl: string; size: IAvatarSize | IAvatarSize[] }): IImageSources => {
    const pixelSize = getAvatarPixelSize(size);
    return buildImageSources({ baseUrl: imageUrl, queryParams: { w: pixelSize, h: pixelSize } });
};
